import { render, staticRenderFns } from "./HistoryLimits.vue?vue&type=template&id=40055cbe&scoped=true&"
import script from "./HistoryLimits.vue?vue&type=script&lang=ts&"
export * from "./HistoryLimits.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryLimits.vue?vue&type=style&index=0&id=40055cbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40055cbe",
  null
  
)

export default component.exports